// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
import { Routes, Route, Navigate } from "react-router-dom"
import ProtectedRoute from "@/routes/ProtectedRoute"
import PasswortWechselPage from "@/routes/PasswortWechselPage"
import LoginPage from "@/routes/LoginPage"
import ProfilePage from "@/routes/ProfilePage"
import StartPage from "@/routes/StartPage"
import LogPage from "@/routes/LogPage"
import HistoryPage from "@/routes/HistoryPage"
import StatsPage from "@/routes/StatsPage"
import PlanPage from "@/routes/PlanPage"
import TrainingPage from "@/routes/TrainingPage"
import FeedPage from "@/routes/FeedPage"
import PlansPage from "@/routes/PlansPage"
import PlanEditPage from "@/routes/PlanEditPage"

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/passwort-setzen" element={<PasswortWechselPage />} />
      <Route path="/" element={<Navigate to="/start" replace />} />
      <Route path="/start" element={<ProtectedRoute><StartPage /></ProtectedRoute>} />
      {/* „Eintragen" ist kein Tab mehr, aber die Seite bleibt: erreichbar über
          „Satz nachtragen" auf Start und über Bearbeiten im Verlauf */}
      <Route path="/log" element={<ProtectedRoute><LogPage /></ProtectedRoute>} />
      <Route path="/training" element={<ProtectedRoute><TrainingPage /></ProtectedRoute>} />
      <Route path="/verlauf" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
      <Route path="/fortschritt" element={<ProtectedRoute><StatsPage /></ProtectedRoute>} />
      <Route path="/plan" element={<ProtectedRoute><PlanPage /></ProtectedRoute>} />
      <Route path="/plaene" element={<ProtectedRoute><PlansPage /></ProtectedRoute>} />
      <Route path="/plaene/:id" element={<ProtectedRoute><PlanPage /></ProtectedRoute>} />
      <Route path="/plaene/:id/bearbeiten" element={<ProtectedRoute><PlanEditPage /></ProtectedRoute>} />
      <Route path="/feed" element={<ProtectedRoute><FeedPage /></ProtectedRoute>} />
      <Route path="/profil" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/log" replace />} />
    </Routes>
  )
}
